import { createClient } from '@supabase/supabase-js';
import type { Database } from './database.types';

// Handle both Vite's import.meta.env (browser) and Node.js process.env (E2E tests)
const getEnvVar = (key: string, defaultValue: string = ''): string => {
    if (typeof import.meta !== 'undefined' && import.meta.env) {
        return import.meta.env[key] || defaultValue;
    }
    // Fallback for Node.js environment (E2E tests)
    if (typeof process !== 'undefined' && process.env) {
        return process.env[key] || defaultValue;
    }
    return defaultValue;
};

const supabaseUrl = getEnvVar('VITE_SUPABASE_URL', 'http://localhost:54321');
const supabaseAnonKey = getEnvVar('VITE_SUPABASE_ANON_KEY', '');

if (!supabaseAnonKey && supabaseUrl.includes('localhost')) {
    console.warn(
        '⚠️  Supabase anon key not found. Please set VITE_SUPABASE_ANON_KEY in your .env file.\n' +
        'Run `npx supabase start` and copy the anon key from the output.'
    );
}

export const supabase = createClient<Database>(supabaseUrl, supabaseAnonKey, {
    auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
        // Only use localStorage in browser environment (not in Node.js/E2E tests)
        storage: typeof window !== 'undefined' ? window.localStorage : undefined,
    },
});

